import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {userLogin} from "../../../services/studentService"


const initialState = {
    loginDetails: {
      status: "idle",
      error: null,
      userDetails: {},
      active: false
    }
}

export const verifyLogin = createAsyncThunk(
    "login/verifyLogin",
    async (data) => {
      const response = await userLogin(data)
      console.log("response",response)
      return response
    }
)
  

export const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        resetUserDetails: (state) => {
            state.loginDetails = initialState.loginDetails
        },
        changeStatus: (state) => {
            state.loginDetails.active = null
        },
    },
    extraReducers: {
      [verifyLogin.pending]: (state) => {
        state.loginDetails.status = "loading"
      },
      [verifyLogin.fulfilled]: (state, action) => {
          console.log("action",action)
        if(action.payload.data && action.payload.status !== 400) {
          state.loginDetails.status = 'succeeded'
          state.loginDetails.userDetails = action.payload
          state.loginDetails.active = true
        }else if(action.payload.status !== 400){
          state.loginDetails.status = "failed"
          state.loginDetails.error = "You Have Entered Invalid Details"
        }else{
          state.loginDetails.status = "failed"
          state.loginDetails.error = "Some Technical Issue, Can't Login"
        }
      },
      [verifyLogin.rejected]: (state, action) => {
        state.loginDetails.status = "failed"
        state.loginDetails.error = action.error.message
      }
    }
  })
  
  export const { resetUserDetails, changeStatus } = loginSlice.actions
  
  export default loginSlice.reducer